const Tracker = require('../../../global/js/modules/google-analytics');

function _init() {
    let $alert = document.querySelector('div.alert-operational-leasing');

    if (!$alert) {
        return;
    }

    let retries = 0;
    let interval = window.setInterval(function () {
        if (retries === 10) {
            window.clearInterval(interval);
            console.error('Unable to find google analytics tracking after 10 retries');
        }

        try {
            Tracker.assertGa();
            window.clearInterval(interval);

            Tracker.track('Form Submission', 'submit', 'Operational Leasing');
        } catch (exception) {
            retries++;
        }
    }, 1000);
}

document.addEventListener('DOMContentLoaded', _init);